module.exports = "/static/assets/d087f19974a4c1d3d2a080189e719387.png";